import { Routes } from '@angular/router';
import { TEMPLATES_SLUGS } from '@routes/routes.types';

export const TEMPLATES_ROUTES: Routes = [
    {
        path: TEMPLATES_SLUGS.table,
        title: 'Preset Messages',
        loadComponent: () =>
            import('@features/templates/templates-table/templates-table.component').then(
                m => m.TemplatesTableComponent
            ),
    },
    {
        path: TEMPLATES_SLUGS.form,
        title: 'Template form',
        loadComponent: () =>
            import(
                '@features/templates/templates-form-content/templates-form-content.component'
            ).then(m => m.TemplatesFormContentComponent),
    },
    {
        path: TEMPLATES_SLUGS.wizard,
        title: 'Template wizard',
        loadComponent: () =>
            import(
                '@features/templates/templates-form-wizard/templates-form-wizard.component'
            ).then(m => m.TemplatesFormWizardComponent),
    },

    {
        path: TEMPLATES_SLUGS.metaForm,
        title: 'Meta template form',
        loadComponent: () =>
            import(
                '@features/templates/meta-templates/meta-template-form/meta-template-form.component'
            ).then(m => m.MetaTemplateFormComponent),
    },
    {
        path: TEMPLATES_SLUGS.meta,
        title: 'Meta templates',
        loadComponent: () =>
            import(
                '@features/templates/meta-templates/meta-templates-table/meta-templates-table.component'
            ).then(m => m.MetaTemplatesTableComponent),
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: TEMPLATES_SLUGS.table,
    },
] as const;
